import React from 'react';
import TeamMemberDigitalCardPreview from 'team/components/TeamMemberDigitalCardPreview';
import TeamQRCodePreview from './qrCode/TeamQRCodePreview';
import TeamVirtualBackgroundPreview from './virtualBackground/TeamVirtualBackgroundPreview';
import TeamEmailSignaturePreview from './emailSignature/TeamEmailSignaturePreview';

const TeamMemberEditPreview = ({ selectedItem, cardId, user }) => {
    return (
        <>
            {/* Always render all preview components but conditionally show/hide */}
            <div style={{ display: selectedItem === 'qrCode' ? 'block' : 'none' }}>
                <TeamQRCodePreview />
            </div>

            <div style={{ display: selectedItem === 'virtualBackground' ? 'block' : 'none' }}>
                <TeamVirtualBackgroundPreview />
            </div>

            <div style={{ display: selectedItem === 'emailSignature' ? 'block' : 'none' }}>
                <TeamEmailSignaturePreview user={user} />
            </div>

            {/* TeamMemberDigitalCardPreview shows for all other menu items */}
            <div style={{ display: !['qrCode', 'virtualBackground', 'emailSignature'].includes(selectedItem) ? 'block' : 'none' }}>
                <TeamMemberDigitalCardPreview cardId={cardId} />
            </div>
        </>
    );
};

export default TeamMemberEditPreview;

